import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Layout, AppRoutes, ScrollToTop } from './components';
import { JWTAuthProvider } from './components/JWTAuthContext.js';
import { getGoogleOAuthConfig } from './components/apiConfig.js';
import { ChatWidget } from './components/help-chatbot';
import './styles/App.css';

function AppContent() {
  const location = useLocation();
  
  // Hide help button on quiz attempt pages for distraction-free experience
  const isQuizAttemptPage = location.pathname.match(/^\/quiz\/[^/]+$/) !== null;
  const isWiziQuizAttemptPage = location.pathname.match(/^\/mock-test\/attempt\/\d+$/) !== null;
  const shouldHideChatWidget = isQuizAttemptPage || isWiziQuizAttemptPage;
  
  return (
    <>
      <ScrollToTop />
      {/* <HighlighterBanner /> */}
      <Layout>
        <AppRoutes />
      </Layout>
      
      {/* Help Chatbot - Floats over all content (hidden during quiz attempts) */}
      {!shouldHideChatWidget && <ChatWidget />}
    </>
  );
}

function App() {
  const googleConfig = getGoogleOAuthConfig();
  
  return (
    <GoogleOAuthProvider clientId={googleConfig.clientId}>
      <JWTAuthProvider>
        <Router>
          <AppContent />
        </Router>
      </JWTAuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
